var BaseView = require('./director');
var ScrollableMixin = require('../mixins/scrollable');

module.exports = Backbone.mixin(BaseView.extend({
  views: {},
  template: require('./categories-director.hbs'),
  CategoriesView: null,

  loadListContent: function (key) {
    var $el = this.$el;
    var $button = $el.find('dt a[data-key="' + key + '"]');

    this.views[key] = new this.CategoriesView({
      el: getNewImageListContainer(),
      key: key
    });

    this.views[key].on('open_new_view', _.partial(this.openSubView, $button));

    return this.views[key];

    function getNewImageListContainer () {
      var $container = $('<div></div>')
        .addClass('image-list');

      if ($button.length) $container.insertAfter($button);
      else $el.find('.wrapper').append($container);

      return $container;
    }
  },

  listContentToggleEvent: function (event) {
    BaseView.prototype.listContentToggleEvent.apply(this, arguments);
    event.stopPropagation();
  },

  initialize: function () {
    _.bindAll(this, '_render', 'initScroll');
    this.scrollRefresh = _.debounce(this.initScroll, 2000);
    BaseView.prototype.initialize.apply(this, arguments);
  },

  toggleAcordionElement: function ($button, value) {
    this.$el.find('.antiscroll-wrap:first > .antiscroll-inner').scrollTop(0);
    this.toggleScroll(value);
    BaseView.prototype.toggleAcordionElement.apply(this, arguments);
  },

  openSubView: function ($button, data) {
    $button.children('.collapse-accordion').addClass('hidden');
    $button.children('.back').removeClass('hidden');

    if (INKIVE.C.IS_MOBILE) return;

    var name = this.getCategoryName(data);
    var $category = $('<span class="category">').text(': ' + name);
    $button.children('.category').remove();
    $button.append($category);
  },

  closeView: function () {
    var hasOpenAccorion = this.$el.find('.wrapper dt.active').length;
    hasOpenAccorion && this.closeAccordion();
    return !hasOpenAccorion;
  },

  closeSubView: function ($button) {
    var key = $button.data('key');
    var isLastSubview = this.views[key].closeView
      ? this.views[key].closeView()
      : true;

    if (isLastSubview) {
      $button.children('.category').remove();
      $button.children('.collapse-accordion').removeClass('hidden');
      $button.children('.back').addClass('hidden');
    }
  },

  getCategoryName: function (data) {
    return '';
  },

  refreshView: function () {
    this.scrollRefresh();
  },

  render: function () {
    INKIVE.Modal.togglePageLoader(true);
    this.loadButtons().then(this._render);
  },

  _render: function (buttons) {
    INKIVE.Modal.togglePageLoader(false);

    this.$el.html(this.template({
      class: this.class,
      buttons: buttons,
      add_button: this.addButtonText
    }));

    this.scrollRefresh();

    if (!buttons.length) {
      this.loadListContent(0);
      this.$el.find('.image-list').css({
        top: 10,
        height: this.$el.closest('[role="tabpanel"]').height()
      });
    }
  },

  getScrollHeight: function () {
    return this.$el.closest('.image-list').height();
  },

  loadButtons: function () {
    var deferred = $.Deferred();
    deferred.resolve([]);
    return deferred.promise();
  }
}), ScrollableMixin);
